/**
 * author Qian.qianchen 2019-04-01
 * 时分秒时间选择器
 * callback为下拉组件原有参数
 * time 设定的时间
 * isShowBtn 是否显示确定、取消按钮
 * 功能为下拉组件基础上增加自定义时间功能
 */
"use strict";
angular.module('timeSelectorWithSecondModule', []).
directive('timeSelectorWithSecond', ['$location', '$filter', 'trsHttpService', '$stateParams', '$state', '$timeout', 'modalDialog', function($location, $filter, trsHttpService, $stateParams, $state, $timeout, modalDialog) {
    return {
        restrict: 'E',
        templateUrl: "./editingCenter/directive/timeSelectorWithSecond/timeSelectorWithSecond_tpl.html",
        scope: {
            placeholder: "@",
            callback: "&",
            time: "=",
            isShowBtn: '=',
            hourMax: '=',
            initialShow: '&',
            isShowSelector: '='
        },
        link: function($scope, iElement, iAttrs) {

            // initStatus();
            // initMouseWheel();
            $scope.$watch('time', function(newVal) {
                if (angular.isDefined(newVal)) {
                    initStatus();
                    initMouseWheel();
                }
            });

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    initialHour: $scope.time.split(":")[0].length > 1 ? $scope.time.split(":")[0] : "0" + $scope.time.split(":")[0],
                    initialMinute: $scope.time.split(":")[1].length > 1 ? $scope.time.split(":")[1] : "0" + $scope.time.split(":")[1],
                    initialSecond: $scope.time.split(":")[2].length > 1 ? $scope.time.split(":")[2] : "0" + $scope.time.split(":")[2]
                };
                $scope.data = {
                    hourArray: new Array($scope.hourMax),
                    hour: $scope.time.split(":")[0].length > 1 ? $scope.time.split(":")[0] : "0" + $scope.time.split(":")[0],
                    minute: $scope.time.split(":")[1].length > 1 ? $scope.time.split(":")[1] : "0" + $scope.time.split(":")[1],
                    second: $scope.time.split(":")[2].length > 1 ? $scope.time.split(":")[2] : "0" + $scope.time.split(":")[2]
                };
                timeFormat();
            }
            /**
             * [initEvent description] 页面点击、鼠标滚动时间绑定
             * @return {[type]} [description]
             */
            function initEvent() {
                $("body").unbind('click', bindBody).bind("click", bindBody);
                $("body").unbind('mousewheel', bindBody).bind("mousewheel", bindBody);
            }

            /**
             * [timeFormat description] 时分秒拼接
             * @return {[type]} [description]
             */
            function timeFormat() {
                $scope.data.time = $scope.data.hour + '：' + $scope.data.minute + '：' + $scope.data.second
            }
            /**
             * [initMouseWheel description] 初始化鼠标滚动事件
             * @return {[type]} [description]
             */
            function initMouseWheel() {
                iElement.find(".hour_container").bind("mousewheel", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.originalEvent.wheelDeltaY < 0) {
                        $scope.timeAdd('hour', $scope.data.hour, $scope.hourMax);
                    } else {
                        $scope.timeMinus('hour', $scope.data.hour, $scope.hourMax);
                    }
                    $scope.$apply();
                });
                iElement.find(".minute_container").bind("mousewheel", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.originalEvent.wheelDeltaY < 0) {
                        $scope.timeAdd('minute', $scope.data.minute, 59);
                    } else {
                        $scope.timeMinus('minute', $scope.data.minute, 59);
                    }
                    $scope.$apply();
                });
                iElement.find(".second_container").bind("mousewheel", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (e.originalEvent.wheelDeltaY < 0) {
                        $scope.timeAdd('second', $scope.data.second, 59);
                    } else {
                        $scope.timeMinus('second', $scope.data.second, 59);
                    }
                    $scope.$apply();
                });
            }
            /**
             * [handleTime description] 时间处理
             * @param  {[number]} time      [description] 时间
             * @param  {[number]} different [description] 偏差
             * @param  {[number]} max       [description] 最大值
             * @return {[string]}           [description]
             */
            function handleTime(time, different, max) {
                time += different;
                if (time > max) {
                    time = max;
                } else if (time < 0) {
                    time = '00';
                } else {
                    time = time > 9 ? time.toString() : "0" + time;
                }
                return time;
            }
            /**
             * [selectorToggle description] 时间选择显示/隐藏
             * @param  {[object]} ev [description] event事件对象
             * @return {[type]}    [description]
             */
            $scope.selectorToggle = function(ev) {
                ev.stopPropagation();
                $scope.initialShow();
                $scope.isShowSelector = !$scope.isShowSelector;
                if ($scope.isShowSelector) {
                    initEvent();
                }
            }
            /**
             * [handleTime description] 时间处理
             * @param  {[number]} time      [description] 时间
             * @param  {[number]} different [description] 偏差
             * @param  {[number]} max       [description] 最大值
             * @return {[string]}           [description]
             */
            $scope.handleTime = function(time, different, max) {
                return handleTime(Number(time), different, max);
            }
            /**
             * [timeMinus description] 时间往上翻（时间减1）
             * @param  {[type]} type [description] 选中的时间段（时、分、秒）
             * @param  {[type]} time [description] 选中的时间段的时间（时、分、秒）
             * @param  {[type]} max  [description] 时间段最大值
             * @return {[type]}      [description]
             */
            $scope.timeMinus = function(ev, type, time, max) {
                ev.stopPropagation();
                $scope.data[type] = handleTime(Number(time), -1, max);
            }
            /**
             * [timeAdd description] 时间往下翻（时间加1）
             * @param  {[type]} type [description] 选中的时间段（时、分、秒）
             * @param  {[type]} time [description] 选中的时间段的时间（时、分、秒）
             * @param  {[type]} max  [description] 时间段最大值
             * @return {[type]}      [description]
             */
            $scope.timeAdd = function(ev, type, time, max) {
                ev.stopPropagation();
                $scope.data[type] = handleTime(Number(time), 1, max);
            }
            /**
             * [setTime description] 时间设置
             * @param {[type]} type   [description] 时间段类型（时、分、秒）
             * @param {[type]} target [description] 目标时间
             */
            $scope.setTime = function(ev, type, target) {
                ev.stopPropagation();
                $scope.data[type] = target;
            }
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function(ev) {
                ev.stopPropagation();
                $scope.isShowSelector = false;
                $scope.data.hour = $scope.status.initialHour;
                $scope.data.minute = $scope.status.initialMinute;
                $scope.data.second = $scope.status.initialSecond;
            }
            /**
             * [confirm description] 确认
             * @return {[type]} [description]
             */
            $scope.confirm = function(ev) {
                ev.stopPropagation();
                $scope.data.time = $scope.data.hour + '：' + $scope.data.minute + '：' + $scope.data.second;
                $scope.time = $scope.data.hour + ':' + $scope.data.minute + ':' + $scope.data.second;
                $scope.isShowSelector = false;
            }

            function bindBody(e) {
                iElement.blur();
                $scope.isShowSelector = false;
                $scope.data.hour = $scope.status.initialHour;
                $scope.data.minute = $scope.status.initialMinute;
                $scope.data.second = $scope.status.initialSecond;
                $scope.$apply();
            };
            $scope.$on("$destroy", function() {
                $("body").unbind("click", bindBody);
                $("body").unbind("mousewheel", bindBody);
            });
        }
    }
}]);